module.exports = __webpack_public_path__ + "components/flag/static/square/ye-fc802cff84ce965f834f1a637ba69177.svg";